<div class="menu-divider" role="separator" aria-hidden="true"></div>

<style>
  .menu-divider {
    flex-shrink: 0;
    height: 1px;
    margin: var(--pd-xs) var(--pd-sm);
    background: var(--divider);
  }
</style>
